/**
 * DEPRECATED: Folder types are deprecated and replaced by Tags with type=FOLDER_UPLOAD.
 *
 * Use TagRead with type=TagType.FOLDER_UPLOAD instead of FolderRead.
 * The folder fields map to tag fields as follows:
 * - name -> tag_name
 * - creation_time -> created_at
 * - review_count -> (removed)
 */

// Keep this constant for "All Documents" virtual folder
export const COMBINED_FOLDER_ID = "00000000-0000-0000-0000-000000000000";

// DEPRECATED: Use TagRead with type=FOLDER_UPLOAD instead
// Kept for backwards compatibility during migration
export interface FolderRead {
    id: string;
    group_id: string;
    submitter_id: string;
    creation_time: string;
    name: string;
    description?: string;
    review_count: number;  // DEPRECATED: No longer tracked
    document_count: number;
}

// DEPRECATED: Use TagCreate with type=FOLDER_UPLOAD instead
export interface FolderCreate {
    group_id: string;
    submitter_id: string;
    name: string;
    description?: string;
}

// DEPRECATED: Use TagUpdate instead
export interface FolderUpdate {
    name?: string;
    description?: string;
}

// DEPRECATED: Use TagResults instead
export interface FolderResults {
    folders: FolderRead[];
}
